import { getUserInfo } from '@/api/user';
import Cookies from 'js-cookie';

const user = {
  state: {
    account: '',
    name: '',
    userId: '',
    avatar: '',
    access: localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo')).permissions
      : [],
    hasGetInfo: !!Cookies.get('user') || false, // 是否获取用户信息
    version: '',
  },
  mutations: {
    setAccount(state, account) {
      state.account = account;
    },
    setName(state, name) {
      state.name = name;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setAvatar(state, avatar) {
      state.avatar = avatar;
    },
    setAccess(state, access) {
      state.access = access;
    },
    setHasGetInfo(state, status) {
      state.hasGetInfo = status;
    },
    setVersion(state, version) {
      state.version = version;
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve) => {
        getUserInfo().then((data) => {
          if (data && data.id) {
            commit('setAccount', data.account);
            commit('setName', data.name);
            commit('setUserId', data.id);
            commit('setAvatar', data.avatar);
            commit('setAccess', data.permissions);
            commit('setHasGetInfo', true);
            localStorage.setItem('userInfo', JSON.stringify(data));
            Cookies.set('user', data.account);
            resolve(data);
          }
        });
      });
    },

    setCurrentAccess({ commit }, setCurrentAccess) {
      commit('setAccess', setCurrentAccess);
    },
  },
};

export default user;
